import { PreferredLivePhotoType } from "@dreamcam/web-sdk";
const defaultValues = {
    "featureMessenger": false,
    "messengerMaxUnreadCount": 999,
    "thumbnailPhotoTypeDefault": PreferredLivePhotoType.livePhoto2D,
    "thumbnailPhotoTypeHover": PreferredLivePhotoType.livePhoto2D,
    "tipsCoinsAnimationStartsAt": 100,
    "tipsLevel1AnimationStartsAt": 31,
    "tipsLevel1AnimationEndsAt": 60,
    "tipsLevel2AnimationStartsAt": 61,
    "tipsLevel2AnimationEndsAt": 99,
    "tipsLevel3AnimationStartsAt": 100,
};
export let globalOptions = JSON.parse(JSON.stringify(defaultValues));
export async function loadGlobalOptionsAsync(url) {
    let loadedGlobalOptions = {};
    if (url !== undefined) {
        try {
            const response = await fetch(url);
            loadedGlobalOptions = await response.json();
        }
        catch (e) {
            console.warn(e);
        }
    }
    globalOptions = Object.assign({}, defaultValues, loadedGlobalOptions);
    const isValidPreferredLivePhotoType = (value) => {
        return Object.values(PreferredLivePhotoType).includes(value);
    };
    if (!isValidPreferredLivePhotoType(globalOptions.thumbnailPhotoTypeDefault)) {
        globalOptions.thumbnailPhotoTypeDefault = defaultValues.thumbnailPhotoTypeDefault;
    }
    if (!isValidPreferredLivePhotoType(globalOptions.thumbnailPhotoTypeHover)) {
        globalOptions.thumbnailPhotoTypeHover = defaultValues.thumbnailPhotoTypeHover;
    }
    // console.log(globalOptions);
}
